import React from 'react';
import PropTypes from 'prop-types';
import CodeInput from '../../../../components/CodeInput';

const StepSecond = ({ getCode, login, btnDisabled, typeVerify, stepBack }) => {
    return (
        <div className="text-center text-md-start">
            <p className="link-back mb-4" onClick={() => stepBack(false)}>&lt; <span>Вернуться к выбору</span></p>
            <p className="mb-3">Введите полученный код <span className="fw-bold">{typeVerify}</span>:</p>
            <div className="row">
                <div className="col-xl-auto d-flex d-md-block justify-content-center">
                    <CodeInput getCode={getCode} />
                </div>
                <div className="col-xl-auto">
                    <button onClick={login} disabled={btnDisabled} className='btn btn_red btn_md mt-4 mt-xl-0'>
                        Готово
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StepSecond;

StepSecond.propTypes = {
    login: PropTypes.func,
    getCode: PropTypes.func,
    typeVerify: PropTypes.string,
    btnDisabled: PropTypes.bool,
    stepBack: PropTypes.func
};